const peerScoreSet = {
  "Choose your role": [0, 0, 0, 0, 0, 0],
  "C-level": [68.25, 74, 40.75, 48, 83.75, 60.5],
  IT: [69.25, 76.75, 49.25, 66, 77.5, 64.75],
  "Business Manager": [77.75, 70.75, 51.5, 45.75, 65.25, 68],
  "End user": [50, 71.5, 39.25, 57.25, 89.25, 47],
};

export default peerScoreSet;
